export const ROUTE_HOME = '/';
export const ROUTE_ITEMS = '/items';
export const ROUTE_CAMPAIGNS = '/campaigns';
export const ROUTE_FUNDRAISERS = '/fundraisers';
export const ROUTE_MESSENGER_SUPPORT = '/messenger/support';
export const ROUTE_ONSITE_CHECKOUT = '/onsite-checkout';
export const ROUTE_CHECKOUT_SUCCESS = '/checkout/success';
